import ChatAnimation from '../../src/legacy/ChatAnimation';
export default ChatAnimation;
